if (typeof ShippingNotice != "function") {
    class ShippingNotice2 extends HTMLElement {
        constructor() {
            super(), this.init()
        }
        init() {
            const freeShippingThreshold = Number(this.getAttribute("data-free-shipping")),
                freeShippingRemaining = Number(this.getAttribute("data-cart-total-amount")) - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
          let percentage = (Number(this.getAttribute("data-cart-total-amount"))/freeShippingThreshold)*100 ;
            let shippingMessage = "",
                shippingSuccess = !1;
            freeShippingRemaining < 0 ? shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace("{{ remaining_amount }}", this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format)) : (shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free, shippingSuccess = !0), this.hasAttribute("data-show-alert") ? this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess?"success":"note"}">
          <div class="progressbar">
            <div class="bar" style="width:${percentage}%"></div>
          </div>
          <div class="message">
            ${shippingMessage}
          </div>
          </div>` : this.innerHTML = shippingMessage
        }
        _formatMoney(cents, format) {
            typeof cents == "string" && (cents = cents.replace(".", ""));
            let value = "";
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                formatString = format || moneyFormat;

            function formatWithDelimiters(number, precision, thousands, decimal) {
                if (thousands = thousands || ",", decimal = decimal || ".", isNaN(number) || number === null) return 0;
                number = (number / 100).toFixed(precision);
                const parts = number.split("."),
                    dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                    centsAmount = parts[1] ? decimal + parts[1] : "";
                return dollarsAmount + centsAmount
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case "amount":
                    value = formatWithDelimiters(cents, 2);
                    break;
                case "amount_no_decimals":
                    value = formatWithDelimiters(cents, 0);
                    break;
                case "amount_with_comma_separator":
                    value = formatWithDelimiters(cents, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    value = formatWithDelimiters(cents, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    value = formatWithDelimiters(cents, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    value = formatWithDelimiters(cents, 2, "'");
                    break
            }
            return formatString.replace(placeholderRegex, value)
        }
    }
    typeof customElements.get("shipping-notice") > "u" && customElements.define("shipping-notice", ShippingNotice2)
}
//# sourceMappingURL=/s/files/1/0096/3254/6913/t/10/assets/component-shipping-notice.js.map?v=1712002513